<script setup lang="ts">
import { computed } from "vue";
import UtilsService from "@/services/others/UtilsService";

interface IProps {
	amount: number | string;
	currency: "RUB" | "USD" | "USDT" | "KZT";
	disabled?: boolean;
}

const props = defineProps<IProps>();
const utilsService = UtilsService.of();
const formatedAmount = computed(() => {
	if (typeof props.amount === "string") return props.amount;

	return utilsService.currencyFormatter(props.currency).format(props.amount);
});
</script>

<template>
	<div :class="[
		'default-amount-button',
		{ disabled }
	]">
		<span class="default-amount-button__amount">{{ formatedAmount }}</span>
	</div>
</template>

<style scoped lang="scss">
.default-amount-button {
	cursor: pointer;
	border: 1px solid var(--f7-theme-color);
	border-radius: 16px;
	color: var(--f7-theme-color);
	font-weight: 400;
	font-size: 18px;
	line-height: 20px;
	letter-spacing: -0.41px;
	padding: 2px 12px;
	background-color: #FFFFFF;

	&:active {
		background-color: var(--f7-theme-color);
		color: #FFFFFF;
	}

	&.selected {
		background-color: var(--f7-theme-color);
		color: #FFFFFF;
	}

	&.disabled {
		opacity: 0.5;
		pointer-events: none;
	}
}
</style>
